import { toast } from 'react-toastify';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppMutation, useInvalidateQueries } from '../../../../hooks/index';
import { ApiService } from '../../../../services/index';
import { AddPerkPayload } from './use-add-perk.hook';

export type DraftPayload = Partial<AddPerkPayload>;

export const useSaveDraft = () => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.PERKS);
  const { mutate: saveDraft, isPending } = useAppMutation([QueryKey.PERKS, QueryKey.POST], {
    mutationFn: ({ data }: { data: DraftPayload }) =>
      ApiService.post(
        {
          endpoint: BackendRoute.PERKS,
          routePath: ['draft'],
        },
        { regularBackend: true, body: data },
      ),
    defaultErrorHandling: false,
    onError: () => {
      toast.error('Couldn’t save draft. Please try again.');
    },
    onSuccess: () => {
      invalidateQuery();
      toast.success('Perk saved as draft');
    },
  });

  return {
    isPending,
    saveDraft,
  };
};
